var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4671_9178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4671_9178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99667 10.4073C7.89154 10.4073 7.78828 10.3855 7.68688 10.342C7.58548 10.2986 7.49758 10.2396 7.42318 10.1652L4.27158 7.01362C4.10163 6.84368 4.01943 6.64989 4.02498 6.43226C4.03054 6.21462 4.11641 6.02271 4.2826 5.85652C4.44879 5.69033 4.6407 5.60724 4.85833 5.60724C5.07597 5.60724 5.26788 5.69033 5.43407 5.85652L8 8.43912L10.5826 5.85652C10.7488 5.69033 10.9407 5.61002 11.1583 5.61557C11.376 5.62113 11.5679 5.707 11.7341 5.87319C11.9003 6.03938 11.9833 6.23129 11.9833 6.44892C11.9833 6.66656 11.8984 6.86003 11.7284 7.02935L8.57682 10.1652C8.49797 10.2396 8.40785 10.2986 8.30645 10.342C8.20505 10.3855 8.10179 10.4073 7.99667 10.4073Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.a50b92478470818d84a1a6e31c6614ba.svg";
export { ForwardRef as ReactComponent };